export const COUNTRY_ACTIONS = {
  SET_IS_LOADING: 'SET_IS_LOADING',
  SET_COUNTRY: 'SET_COUNTRY',
}
